import {
  Affiliatesvg,
  Companysvg,
  Conatactussvg,
  Dashboardsvg,
  Gallerysvg,
  Newsroomsvg,
  PaymentHistorysvg,
  Pricingsvg,
  Prmanage,
  Supportsvg,
} from "../../../public/svgs/svg";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./Sidebar.css";

export default function Sidebar({ activeSide }) {
  const [activeTab, setActiveTab] = useState(activeSide);
  const [showFullSidebar, setShowFullSidebar] = useState(false);
  const [hoveredTab, setHoveredTab] = useState(null);

  useEffect(() => {
    setActiveTab(activeSide);
  }, [activeSide]);

  useEffect(() => {
    const handleToggle = () => setShowFullSidebar(prev => !prev);
    window.addEventListener('toggle-sidebar', handleToggle);
    return () => window.removeEventListener('toggle-sidebar', handleToggle);
  }, []);

  return (
    <>
      <div
        className={`sidebar_overlay ${showFullSidebar ? "show" : ""} d-lg-none`}
        onClick={() => setShowFullSidebar(false)}
      ></div>

      <aside
        className={`sidebar ${showFullSidebar ? "show_mobile" : ""}`}
        style={{ backgroundImage: "url('/img/sidebarLines.svg')" }}
      >
        <div className="d-flex justify-content-start align-items-center logo_container_mobile position-relative">
          <Link to="/customer/dashboard" onClick={() => setShowFullSidebar(false)}>
            <div className={`logo_wrapper`}>
              <img
                className={""}
                src="/build/img/imglogowhite.svg"
                alt="zex pr wire Logo"
                width={110}
                height={50}
              />
            </div>
          </Link>
          <div
            className="d-lg-none close_sidebar_icon"
            onClick={() => setShowFullSidebar(false)}
            style={{ cursor: "pointer" }}
          >
            <img
              src="/build/img/close-menu.svg"
              alt="close"
              width={24}
              height={24}
              style={{ filter: "brightness(0) invert(1)" }}
            />
          </div>
        </div>
        <div className="sidebar_hr"></div>

        <div className="sidebar_content">
          <ul className={`ps-0 nav_items_container`}>
            <li
              className={`cursor-pointer nav_item${activeTab === 1 ? "_active" : ""
                }`}
              onClick={() => setActiveTab(1)}
              onMouseEnter={() => setHoveredTab(1)}
              onMouseLeave={() => setHoveredTab(null)}
            >
              <Link to="/customer/dashboard" onClick={() => setShowFullSidebar(false)}>
                <Dashboardsvg fill={`${activeTab === 1 || hoveredTab === 1 ? "#FFFFFF" : "#8B8EA5"}`} />
                <span
                  className={`${showFullSidebar ? "" : "d-none"} d-lg-inline`}
                >
                  Dashboard
                </span>
              </Link>
            </li>
            <li
              className={`cursor-pointer nav_item${activeTab === 2 ? "_active" : ""
                }`}
              onClick={() => setActiveTab(2)}
              onMouseEnter={() => setHoveredTab(2)}
              onMouseLeave={() => setHoveredTab(null)}
            >
              <Link to="/customer/pr-manager" onClick={() => setShowFullSidebar(false)}>
                <Prmanage fill={`${activeTab === 2 || hoveredTab === 2 ? "#FFFFFF" : "#8B8EA5"}`} />
                <span
                  className={`${showFullSidebar ? "" : "d-none"} d-lg-inline`}
                >
                  PR Manager
                </span>
              </Link>
            </li>
            <li
              className={`cursor-pointer nav_item${activeTab === 3 ? "_active" : ""
                }`}
              onClick={() => setActiveTab(3)}
              onMouseEnter={() => setHoveredTab(3)}
              onMouseLeave={() => setHoveredTab(null)}
            >
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip>Manage team access to PR campaigns.</Tooltip>}
              >
                <Link to="/customer/sub-account" onClick={() => setShowFullSidebar(false)}>
                  <Companysvg fill={`${activeTab === 3 || hoveredTab === 3 ? "#FFFFFF" : "#8B8EA5"}`} />
                  <span
                    className={`${showFullSidebar ? "" : "d-none"} d-lg-inline`}
                  >
                    Sub-accounts
                  </span>
                </Link>
              </OverlayTrigger>
            </li>
            <li
              className={`cursor-pointer nav_item${activeTab === 4 ? "_active" : ""
                }`}
              onClick={() => setActiveTab(4)}
              onMouseEnter={() => setHoveredTab(4)}
              onMouseLeave={() => setHoveredTab(null)}
            >
              <Link to="/customer/gallery" onClick={() => setShowFullSidebar(false)}>
                <Gallerysvg fill={`${activeTab === 4 || hoveredTab === 4 ? "#FFFFFF" : "#8B8EA5"}`} />
                <span
                  className={`${showFullSidebar ? "" : "d-none"} d-lg-inline`}
                >
                  Gallery
                </span>
              </Link>
            </li>
            <li
              className={`cursor-pointer nav_item${activeTab === 5 ? "_active" : ""
                }`}
              onClick={() => setActiveTab(5)}
              onMouseEnter={() => setHoveredTab(5)}
              onMouseLeave={() => setHoveredTab(null)}
            >
              <Link to="/customer/payment" onClick={() => setShowFullSidebar(false)}>
                <PaymentHistorysvg
                  fill={`${activeTab === 5 || hoveredTab === 5 ? "#FFFFFF" : "#8B8EA5"}`}
                />
                <span
                  className={`${showFullSidebar ? "" : "d-none"} d-lg-inline`}
                >
                  Payment History
                </span>
              </Link>
            </li>
            <li className={`nav_item`}>
              <div className={`nav_line`}></div>
            </li>
            <li
              className={`cursor-pointer nav_item${activeTab === 6 ? "_active" : ""
                }`}
              onClick={() => setActiveTab(6)}
              onMouseEnter={() => setHoveredTab(6)}
              onMouseLeave={() => setHoveredTab(null)}
            >
              <Link to="/customer/newsroom" target="_blank" onClick={() => setShowFullSidebar(false)}>
                <Newsroomsvg fill={`${activeTab === 6 || hoveredTab === 6 ? "#FFFFFF" : "#8B8EA5"}`} />
                <span
                  className={`${showFullSidebar ? "" : "d-none"} d-lg-inline`}
                >
                  News room
                </span>
              </Link>
            </li>

            {/* <li
              className={`cursor-pointer nav_item${activeTab === 7 ? "_active" : ""
                }`}
              onClick={() => setActiveTab(7)}
              onMouseEnter={() => setHoveredTab(7)}
              onMouseLeave={() => setHoveredTab(null)}
            >
              <Link to="/customer/affiliate-center" onClick={() => setShowFullSidebar(false)}>
                <Affiliatesvg fill={`${activeTab === 7 || hoveredTab === 7 ? "#FFFFFF" : "#8B8EA5"}`} />
                <span
                  className={`${showFullSidebar ? "" : "d-none"} d-lg-inline`}
                >
                  Affiliate Center
                </span>
              </Link>
            </li> */}
            <li
              className={`cursor-pointer nav_item${activeTab === 8 ? "_active" : ""
                }`}
              onClick={() => setActiveTab(8)}
              onMouseEnter={() => setHoveredTab(8)}
              onMouseLeave={() => setHoveredTab(null)}
            >
              <Link to="/customer/pricing" target="_blank" onClick={() => setShowFullSidebar(false)}>
                <Pricingsvg fill={`${activeTab === 8 || hoveredTab === 8 ? "#FFFFFF" : "#8B8EA5"}`} />
                <span
                  className={`${showFullSidebar ? "" : "d-none"} d-lg-inline`}
                >
                  Pricing
                </span>
              </Link>
            </li>
            <li
              className={`cursor-pointer nav_item${activeTab === 9 ? "_active" : ""
                }`}
              onClick={() => setActiveTab(9)}
              onMouseEnter={() => setHoveredTab(9)}
              onMouseLeave={() => setHoveredTab(null)}
            >
              <Link to="/customer/support" onClick={() => setShowFullSidebar(false)}>
                <Supportsvg fill={`${activeTab === 9 || hoveredTab === 9 ? "#FFFFFF" : "#8B8EA5"}`} />
                <span
                  className={`${showFullSidebar ? "" : "d-none"} d-lg-inline`}
                >
                  Support
                </span>
              </Link>
            </li>
            <li
              className={`cursor-pointer nav_item${activeTab === 10 ? "_active" : ""
                }`}
              onClick={() => setActiveTab(10)}
              onMouseEnter={() => setHoveredTab(10)}
              onMouseLeave={() => setHoveredTab(null)}
            >
              <Link to="/customer/contact" onClick={() => setShowFullSidebar(false)}>
                <Conatactussvg
                  fill={`${activeTab === 10 || hoveredTab === 10 ? "#FFFFFF" : "#8B8EA5"}`}
                />
                <span
                  className={`${showFullSidebar ? "" : "d-none"} d-lg-inline`}
                >
                  Contact Us
                </span>
              </Link>
            </li>
          </ul>
          <div
            className={`help_box ${showFullSidebar ? "" : "d-none"} d-lg-block `}
            style={{
              position: "relative",
            }}
          >
            <div style={{ position: "absolute", left: "0", bottom: "0" }}>
              <img src="/build/img/lines.svg" alt="" />
            </div>
            <p className={`help_first`}>Need help using the product?</p>
            <p className={`help_second`}>
              Click on the button below to get detailed informational videos on
              youtube.
            </p>
            <div className="d-flex justify-content-center">
              <button className={`learn_btn`}>
                <span>Learn More</span>
              </button>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
}
